import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

const mutation = graphql`
    mutation createEventMutation($input: createHyeventInput!){
        createHyevent(input:$input) {
          clientMutationId
          hyevent{
            approverName
            inviteScheduledAt
            approvedAt
            disapprovedAt
            id
            title
            maxNoOfGuests
            additionalGuestAllowed
            maxAdditionalGuests
            ctaText
            disapproveReason
            messageTitle
            message
            address
            placeName
            status
            propertyId
            startAt
            endAt
            publishAt
            cancelReason
            rsvpedCount
            landingPageHtml
            invitedGroups
            confirmPageHtml
            confirmSmsBody
            flyerHtml
            waitlistedPageHtml
            cancelRsvpPageHtml
            removeFromWaitlistPageHtml
            inviteEmailCampaignId
            campaignTested
            image{
              id
              fileType
              fileSize
              fileUrl
              dimension
              thumbnailUrl
            }
            document{
              createdAt
              dimension
              fileSize
              fileType
              fileUrl
              id
              name
              thumbnailUrl
            }
            eventType
            zoomLink
            meetingId
            passcode         
            smsEnabled
            displayTime
            leadFields
            rsvpFormHeader
            enableThankYouEmail
            enableCancelEmail
            enableInviteEmail
            enableMorningReminderEmail
            enableNightReminderEmail
            enableRescheduleEmail
            enableRsvpCancelledEmail
            enableRsvpedEmail
            enableWaitlistOpeningEmail
            enableWaitlistedEmail
            emailList
            recurringEventType
            repeatType
            recurrenceType
            recurrenceEndDate
            recurringDaysList
          }
        }
    }
`;

function commit(environment, input) {
  return new Promise((res, rej) => {
    commitMutation(environment, {
      mutation,
      variables: { input },
      updater: (store) => {
        // const payload = store.getRootField('createHyevent');
        // const draftStore = store.getRoot();
        // draftStore.setLinkedRecord(payload, 'draft');
      },
      onCompleted: res,
      onError: rej
    })
  });
}

export default commit;